import { memo } from 'react'

import { StatRec } from '@/components/common/Stat'
import { type RecType } from '@/defs/rec'
import { type StatType } from '@/defs/stat'
import { cn } from '@/utils/commonUtil'

import styles from './CardStats.module.scss'

type Props = {
  isInView?: boolean
  rec: RecType
  size?: 'sm'
  stats: StatType[]
}

const CardStatsInner = ({ isInView, rec, size, stats }: Props) => (
  <div className={cn(styles.container, { count: String(Math.min(stats.length || 0, 3)), size, styles })}>
    {stats.length > 0 && (
      <ul className={styles.inner}>
        {stats.map((stat) => (
          <li className={styles.item} key={stat}>
            <StatRec isInView={isInView} rec={rec} stat={stat} />
          </li>
        ))}
      </ul>
    )}
  </div>
)

export const CardStats = memo(CardStatsInner)
